<!--
* @description  参数1
* @fileName  noResults
* @author userName
* @date 2024-04-11 16:45:00
!-->
<template>
  <div id="noResults" class="noResults">
    <img src="../../assets/img/client/check/noList.png" width="120px" height="104px">
    <p>No results found</p>
    <p>We cannot find any results that match your search. Please try again with different search terms.</p>
  </div>
</template>

<script>
export default {
  props: {
    // 父辈向子辈传参
  },
  name: "noResults",
  data() {
    return {};
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
  },
  methods: {
    // 方法
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang='scss'>
.noResults{
    margin-top: 154px;
    p:nth-of-type(1){
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 550;
        font-size: 14px;
        color: #333333;
        line-height: 8px;
        text-align: center;
        font-style: normal;
    }
    p:nth-of-type(2){
        font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
        font-weight: 400;
        font-size: 13px;
        color: #777777;
        line-height: 8px;
        text-align: center;
        font-style: normal;
    }
}
</style>